import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Repository } from './repository';
import { CountriesMapApi } from '../api/countries-map-api';
import { MetaObject } from 'src/app/shared/common';

@Injectable({
  providedIn: 'root',
})
export class CountriesMapRepository extends Repository {
  constructor(private countriesMapApi: CountriesMapApi) {
    super();
  }
  getCountriesMapJson(): Observable<MetaObject> {
    return this.countriesMapApi.getCountriesMapJson();
  }
}
